import React from 'react';
import Sectionbg from "../../assets/images/section-bg.png"
import Featurebg from "../../assets/images/device-feature.png"

function Features() {
  const features = [
    {
      image: 'secure.png',
      title: 'Secure data',
      description: 'Lorem Ipsum is simply dummy text of the printing and type setting indus ideas.',
      duration: 1500,
    },
    {
      image: 'abt_functional.png',
      title: 'Automate everything',
      description: 'Simply dummy text of the printing and typesetting indus lorem Ipsum is dummy.',
      duration: 1700,
    },
    {
      image: 'communication.png',
      title: 'Secure data',
      description: 'Lorem Ipsum is simply dummy text of the printing and type setting indus ideas.',
      duration: 1900,
    },
    {
      image: 'abt_support.png',
      title: 'Secure data',
      description: 'Simply dummy text of the printing and typesetting indus lorem Ipsum is dummy.',
      duration: 1900,
    },
  ];

  return (
    <section className="row_am features_section features-gredient" id="features">
      <div className="feature_section_bg">
        <img src={Sectionbg} alt="image" />
      </div>
      <div className="container">
        <div className="features_inner">
          <div className="feature_img new" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="100">
            <img src={Featurebg} alt="image" />
          </div>
          <div className="section_title" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="300">
            <h2>
              <span>Features</span> that makes app different!
            </h2>
            <p>
              Lorem Ipsum is simply dummy text of the printing and typese tting <br /> indus orem Ipsum has beenthe
              standard dummy.
            </p>
          </div>
          <div className="features_block">
            <div className="row">
              {features.map((feature, index) => (
                <div className="col-md-3" key={index}>
                  <div className="feature_box" data-aos="fade-up" data-aos-duration={feature.duration}>
                    <div className="image">
                      <img src={`assets/images/${feature.image}`} alt="image" />
                    </div>
                    <div className="text">
                      <h4>{feature.title}</h4>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
